<template>
  <section class="terms">
    <div class="terms__wrapper">
      <BaseTitle class="terms__title" :text="titleText" :tag="'h1'" />
      <BaseCaption
        class="terms__caption  terms__caption--font-big"
        :text="captionText"
        :tag="'h2'"
      />
      <div ref="content" class="terms__content"></div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import TermsTextItem from '~/components/TermsTextItem'

export default {
  computed: {
    titleText() {
      return this.messages.terms.title
    },
    captionText() {
      return this.messages.terms.caption
    },
    content() {
      return this.messages.terms.content
    },
    ...mapState('data', ['messages'])
  },
  components: {
    TermsTextItem
  },
  mounted() {
    this.$refs.content.innerHTML = this.content
  }
}
</script>

<style lang="scss">
.terms {
  &__wrapper {
    @include container;

    position: relative;
    padding: 76px 16px 50px;

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      left: -111px;
      width: (541/320) * 100%;
      width: 541px;
      height: 958px;
      background: url('~/static/img/terms-bg@mb.svg') repeat-y top center;
      background-size: cover;
    }
  }

  &__content {
    ol {
      counter-reset: item;
      margin: 0;
      padding: 0;
      list-style: none;

      & > li > ol > li {
        margin-bottom: 0;
        color: #595d60;
        font-family: $ToyotaBook;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
      }

      li {
        counter-increment: item;
        margin-bottom: 10px;
        color: #595d60;
        font-family: $ToyotaBook;
        font-size: 15px;
        font-weight: 700;
        line-height: 18px;

        &:before {
          content: counters(item, '.') ' ';
          display: inline-block;
          margin-right: 10px;
        }
      }
    }

    p {
      margin: 0;
      color: #595d60;
      font-family: $ToyotaBook;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;

      strong {
        display: block;
        margin-bottom: 20px;
        font-size: 15px;
        font-weight: 700;
        line-height: 18px;
        text-transform: uppercase;
      }

      &:not(:last-of-type) {
        margin-bottom: 20px;
      }
    }
  }

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &__item {
    margin-bottom: 20px;
  }

  &__title {
    margin: 0 0 20px;
  }

  &__caption {
    margin: 0 0 20px;

    &--font-big {
      margin-bottom: 20px;
      font-size: 16px !important;
      line-height: 24px !important;
      text-transform: uppercase;
    }
  }

  &__descr {
    margin: 0;

    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
  }
}

@include media-min($tablet-width) {
  .terms {
    &__wrapper {
      padding: 96px 25px 64px;

      &::before {
        left: -116px;
        width: 1009px;
        height: 805px;
        background: url('~/static/img/terms-bg@tl.svg') no-repeat center;
        background-size: cover;
      }
    }

    &__item {
      margin-bottom: 30px;

      &:last-of-type {
        margin-bottom: 20px;
      }
    }

    &__content {
      p {
        font-size: 12px;
        font-family: $ToyotaBook;
        font-weight: 400;
        line-height: 18px;

        strong {
          font-size: 15px;
          font-weight: 700;
          line-height: 18px;
        }
      }
    }

    &__title {
      margin-bottom: 26px;
    }

    &__caption {
      margin: 0 0 20px;

      &--font-big {
        margin-bottom: 30px;
        font-size: 20px !important;
        line-height: 23px !important;
      }
    }
  }
}

@include media-min($desktop-width) {
  .terms {
    &__wrapper {
      padding: 110px 60px 141px;

      &::before {
        left: -116px;
        width: 1673px;
        height: 1472px;
        background: url('~/static/img/terms-bg@dt.svg') no-repeat center;
        background-size: cover;
      }
    }

    &__item {
      margin-bottom: 40px;
    }

    &__content {
      p {
        font-size: 16px;
        font-family: $ToyotaBook;
        font-weight: 400;
        line-height: 25.6px;

        strong {
          font-size: 17px;
          font-weight: 700;
          line-height: 23px;
        }

        &:not(:last-of-type) {
          margin-bottom: 30px;
        }
      }
    }

    &__caption {
      &--font-big {
        margin-bottom: 42px;
        font-size: 24px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/TermsTextBlock.vue